import { TableCell } from '@mui/material';

export default function MemberActivityCell({ activity = 'online' }) {
  return (
    <TableCell>
      <div
        className={`activity ${activity === 'online' ? 'activity--active' : ''}`}
      >
        <div></div>
        {activity}
      </div>
    </TableCell>
  );
}
